import { useCallback, useEffect, useState } from 'react';
import { ParkService } from '../../services/park/parkService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage parks fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de parks.
----------------------------------------------------------------------------------------*/

const useParks = (filterPark = false, initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999, 
        filter_filters: { ...initialFilters }  
    });


    const fetchParks = async (filterPark:boolean) => {
        try {
            const service = new ParkService();

            const response = await service.listForSelect(filters);
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data && filterPark === false) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }else if (fetchedData && fetchedData?.data && filterPark === true) {
                const mappedData = fetchedData.data?.map((data: { id: string; municipal: string; }) => ({
                    value: data.municipal,
                    label: data.municipal,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching parks:', error);
        }
    };

    useEffect(() => {
        fetchParks(filterPark);
    }, [filters]);

    const updateParksHookFilters = (newFilters: any) => {
        setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));;
    };

    const getParksList = () => {
        return data;
    };

    return { fetchParks, getParksList, updateParksHookFilters };
}

export default useParks;